import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css';
import HomeImg from '../../../images/home/home1.png';
import HomeImgMob from '../../../images/home/home375.png';
import HomeImgTab from '../../../images/home/home765.png';
import { Container } from 'components/baseStyles/CommonStyle.styled';
import {
  EventsBox,
  EventsImg,
  HomeDiv,
  HomeEvents,
  HomeImag,
  HomeImagBox,
  HomeImagLink,
  HomeImagTextBox,
  HomeImagTitile,
  HomeMenu,
  HomeMenuList,
  HomeMenuListItem,
  HomeMenuTitle,
  HomePhoto,
  MenuDay,
  MenuItem,
  MenuItemBox,
  SliderBox,
  SliderImg,
} from './Home.styled';
import { useEffect, useState } from 'react';
import menuData from '../../data/menu.json';
import { Keyboard, Mousewheel, Navigation, Pagination } from 'swiper/modules';

import home2 from '../../../images/home/home2.jpg';
import home3 from '../../../images/home/home3.jpg';
import home4 from '../../../images/home/home4.jpg';
import home5 from '../../../images/home/home5.jpg';
import home6 from '../../../images/home/home6.jpg';
import home7 from '../../../images/home/home7.jpg';
import home8 from '../../../images/home/home8.jpg';
import events1 from '../../../images/home/events1.jpg';

import { useTranslation } from 'react-i18next';

export const Home = () => {
  const { t } = useTranslation();
  const [menu, setMenu] = useState([]);

  useEffect(() => {
    setMenu(menuData);
  }, []);

  const photoData = [
    {
      id: '1',
      title: '2',
      src: home2,
    },
    {
      id: '2',
      title: '3',
      src: home3,
    },
    {
      id: '3',
      title: '4',
      src: home4,
    },
    {
      id: '4',
      title: '5',
      src: home5,
    },
    {
      id: '5',
      title: '6',
      src: home6,
    },
    {
      id: '6',
      title: '7',
      src: home7,
    },
    {
      id: '7',
      title: '8',
      src: home8,
    },
  ];

  return (
    <HomeDiv>
      <HomeImagBox>
        <HomeImag src={HomeImg} alt="" />
        <HomeImag src={HomeImgTab} alt="" />
        <HomeImag src={HomeImgMob} alt="" />

        <HomeImagTextBox>
          <HomeImagTitile>
            {t('Entdecken Sie unser Speisekarte')}
          </HomeImagTitile>
          <HomeImagLink to="/menu">A la Carte</HomeImagLink>
        </HomeImagTextBox>
      </HomeImagBox>

      <Container>
        {/* Menu */}
        <HomeMenu>
          <HomeMenuTitle>{t('Menü der Woche')}</HomeMenuTitle>
          <MenuDay style={{ marginTop: 15, fontSize: 22 }}>
            {t('Dienstag')} - {t('Freitag')}
          </MenuDay>

          <HomeMenuList>
            {menu.map(it => (
              <HomeMenuListItem key={it.id}>
                <MenuDay style={{ marginBottom: 7 }}>{it.menuNum}</MenuDay>
                <MenuDay>{it.price}</MenuDay>
                <MenuItemBox>
                  <MenuItem>{it.suppe}</MenuItem>
                  <MenuItem>{it.mainDish}</MenuItem>
                </MenuItemBox>
              </HomeMenuListItem>
            ))}
          </HomeMenuList>
        </HomeMenu>

        {/* Work time */}
        <HomeMenu>
          <HomeMenuTitle>{t('Warme Küche')}</HomeMenuTitle>
          <br />
          <MenuDay style={{ marginTop: 15, fontSize: 22 }}>
            {t('Dienstag')} - {t('Samstag')}
          </MenuDay>

          <MenuDay style={{ marginTop: 10, fontSize: 22 }}>
            11:00 - 14:00 - 17:00-21:00
          </MenuDay>
          <br />
          <MenuDay style={{ marginTop: 15, fontSize: 22 }}>{t("Sonntag")}</MenuDay>

          <MenuDay style={{ marginTop: 10, fontSize: 22 }}>
            11:00 - 14:00
          </MenuDay>
        </HomeMenu>

        {/* Evenst */}
        <HomeEvents>
          <HomeMenuTitle>{t('Veranstaltungen')}</HomeMenuTitle>
          <EventsBox>
            <EventsImg src={events1} alt="Events" />
          </EventsBox>
        </HomeEvents>

        {/* Photo local */}
        <HomePhoto>
          <HomeMenuTitle>{t('Unser Restaurant')}</HomeMenuTitle>
          <SliderBox>
            <Swiper
              modules={[Navigation, Pagination, Mousewheel, Keyboard]}
              spaceBetween={50}
              slidesPerView={1}
              navigation
              // pagination={{ clickable: true }}
              mousewheel={true}
              keyboard={true}
              loop={true}
              loopPreventsSliding={true}
              loopedSlides={1}
            >
              {photoData.map(image => (
                <SwiperSlide key={image.id}>
                  <SliderImg src={image.src} alt={image.title} />
                </SwiperSlide>
              ))}
            </Swiper>
          </SliderBox>
        </HomePhoto>
      </Container>
    </HomeDiv>
  );
};
